import React, {Component} from 'react';
import logo from './logo.svg';
import './App.css';
import 'semantic-ui-css/semantic.min.css';
import {
    Card,
    Icon,
    Image,
    Container,
    Grid,
    Header,
    Button,
    Segment,
    Form,
    Checkbox,
    Input,
    Radio,
    Select,
    TextArea
} from 'semantic-ui-react';
import Navbar from './Navbar';
import Footer from './Footer';
import {Parallax, Background} from 'react-parallax';
import {
    Route,
    HashRouter
} from "react-router-dom";

const numImages = 21;

let seed = 3;

function random() {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
}

const IntroPage = () => (
    <Parallax
        bgImage={'/images/bg.jpg'}
        bgImageAlt="bg"
        strength={1000}
    >
        <Container text style={{color: '#fffffff'}}>
            <div key='spacer' style={{height: 100}}/>
            <Header as='h1' inverted className='white'>Openito</Header>
            <p className='inverted'>
                Connecting communities.
            </p>
            <Button primary> Join Now </Button>
            <div key='spacer' style={{height: 100}}/>
        </Container>
    </Parallax>
);

const EventCard = (props) => (
    <Card raised fluid>
        <Image src={`/images/event/image-${1 + Math.floor(numImages * random())}.jpg`}/>
        <Card.Content>
            <Card.Header>{props.title}</Card.Header>
            <Card.Meta>
                <span className='date'>{(props.date || new Date()).toLocaleDateString()}</span>
            </Card.Meta>
            <Card.Description>{props.description}</Card.Description>
        </Card.Content>
        <Card.Content extra>
            <a>
                <Icon name='user'/>
                {props.numAttending} Attending
            </a>
        </Card.Content>
    </Card>
);

class MainContent extends Component {
    state = {events: []};

    componentWillMount() {
        this.setState({
            events: [
                {
                    title: 'PygHack',
                    date: new Date(),
                    description: 'A 24 hour hackathon bringing together the campus and community to build and innovate for the greater good of Champaign-Urbana',
                    numAttending: 34
                },
                {
                    title: 'End of Summer Picnic',
                    date: new Date(2018, 8, 31),
                    description: 'An end of Summer party to get together and have some fun',
                    numAttending: 67
                },
                {
                    title: 'Coding Thursdays',
                    date: new Date(2018, 9, 4),
                    description: 'Feel free to come to work, or to discuss something you want to learn as a group.',
                    numAttending: 2
                },
                {
                    title: 'Gaming Group',
                    date: new Date(2018, 9, 7),
                    description: 'Bring a laptop and hang out with us for our weekly get-together.',
                    numAttending: 4
                },
                {
                    title: 'Block Party',
                    date: new Date(2018, 9, 8),
                    description: "Let's get together to celebrate the end of the summer and get to know some neighbors.",
                    numAttending: 16
                },
                {
                    title: '54',
                    date: new Date(2018, 9, 5),
                    description: "A 3-day event where students from different backgrounds come together to form teams and launch a successful startup",
                    numAttending: 65
                }
            ]
        });
    }

    render() {
        const cols = 3;
        return (
            <Grid>

                {[...Array(Math.floor(this.state.events.length / cols) + 1).keys()].map(rowNum => (
                    <Grid.Row columns={cols}>
                        {[...Array(Math.min(this.state.events.length - rowNum * cols, cols)).keys()].map(colNum => {
                                console.log(this.state.events.length - rowNum * cols, cols, colNum);
                                let e = this.state.events[cols * rowNum + colNum];
                                return <Grid.Column key={e.title}><EventCard key={e.title} title={e.title} date={e.date}
                                                                             description={e.description}
                                                                             numAttending={e.numAttending}/> </Grid.Column>;
                            }
                        )}
                    </Grid.Row>
                ))}

            </Grid>
        );
    }
}

const MainPage = () => [
    <IntroPage/>,
    <div style={{height: 40}}/>,
    <Container>
        <MainContent/>
    </Container>
];

const options = [
    {key: 'm', text: 'Male', value: 'male'},
    {key: 'f', text: 'Female', value: 'female'},
];

class CollectInfoPage extends Component {
    handleChange = () => {

    };

    render() {
        return (
            <Container>
                <div style={{height: 40}}/>
                <Header>About Your Community</Header>
                <Grid centered>
                    <Grid.Row>
                        <Grid.Column computer={6} tablet={12} mobile={16}>
                            <Segment fluid raised style={{padding: 20}}>
                                <Form>
                                    <Form.Group inline>
                                        <label>Friendliness</label>
                                        <Form.Field
                                            control={Radio}
                                            label='1'
                                            value='1'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='2'
                                            value='2'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='3'
                                            value='3'
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group inline>
                                        <label>Safety</label>
                                        <Form.Field
                                            control={Radio}
                                            label='1'
                                            value='1'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='2'
                                            value='2'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='3'
                                            value='3'
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group inline>
                                        <label>Schools</label>
                                        <Form.Field
                                            control={Radio}
                                            label='1'
                                            value='1'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='2'
                                            value='2'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='3'
                                            value='3'
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group inline>
                                        <label>Dining</label>
                                        <Form.Field
                                            control={Radio}
                                            label='1'
                                            value='1'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='2'
                                            value='2'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='3'
                                            value='3'
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group inline>
                                        <label>Local Produce</label>
                                        <Form.Field
                                            control={Radio}
                                            label='1'
                                            value='1'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='2'
                                            value='2'
                                            onChange={this.handleChange}
                                        />
                                        <Form.Field
                                            control={Radio}
                                            label='3'
                                            value='3'
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                    <Route render={({history}) => (
                                        <Form.Field control={Button}
                                                    onClick={() => {history.push("/");}}
                                        >
                                            Continue
                                        </Form.Field>
                                    )}/>
                                </Form>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

class AddEventPage extends Component {
    render() {
        return (
            <Container>
                <div style={{height: 40}}/>
                <Header>Add Event</Header>
                <Grid centered>
                    <Grid.Row>
                        <Grid.Column computer={6} tablet={12} mobile={16}>
                            <Segment fluid raised style={{padding: 20}}>
                                <Form>
                                    <Form.Group inline>
                                        <label>Organizer</label>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field control={Input} label='First name' placeholder='First name'/>
                                        <Form.Field control={Input} label='Last name' placeholder='Last name'/>
                                    </Form.Group>
                                    <Form.Group inline>
                                        <label>Event Info</label>
                                    </Form.Group>
                                    <Form.Field control={Input} label='Location' placeholder='Where will it be held?'/>
                                    <Form.Field control={Input} label='Time' placeholder='When will it be held?'/>
                                    <Form.Field control={TextArea} label='Description'
                                                placeholder='Tell us about your event...'/>
                                    <Form.Field control={Checkbox} label='I agree to the Terms and Conditions'/>
                                    <Route render={({history}) => (
                                        <Form.Field control={Button}
                                                    onClick={() => {history.push("/collectInfo");}}
                                        >
                                            Continue
                                        </Form.Field>
                                    )}/>
                                </Form>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

class App extends Component {
    render() {
        return (
            <HashRouter>
                <div className="App Site">
                    <div className="Site-content">
                        <div className="App-header">
                            <Navbar key='navbar'/>
                        </div>
                        <div className="main">
                            <Route exact path="/" component={MainPage}/>
                            <Route exact path="/addEvent" component={AddEventPage}/>
                            <Route exact path="/collectInfo" component={CollectInfoPage}/>
                        </div>
                    </div>
                    <Footer key='footer'/>
                </div>
            </HashRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js